import React, { useContext } from "react";

const LimitsContext = React.createContext<API.Limits.DisplayLimits>({});
export const LimitsContextProvider = ({ children }: { children: React.ReactNode }) => {
  const limits = JSON.parse(document.querySelector("[data-limits-json]")?.getAttribute("data-limits-json") || "{}") as API.Limits.DisplayLimits;
  return (
    <LimitsContext.Provider value={limits}>
      {children}
    </LimitsContext.Provider>
  );
};

export const useLimits = () => useContext(LimitsContext);

export default LimitsContext;